<template>
	<div class="page-container">
		<HeaderLayout></HeaderLayout>
		
		
		
						<!-- div class="repleBox" v-if="bid=='question'">
							<span v-if="info.summary">답변완료</span>
							<span style='color:#f00;' v-else>답변대기중</span>

						</div -->
		
		 <div class="content">
	         <div class="content-main">
	               <div class="box-table">
				        <div class="board-header">
							<div>
								<h3 class="text-table">{{boardName}}</h3>
							</div>
							<div>
								<md-button v-if="bid=='question'" class="md-raised md-primary" @click="writeBoard()">
								글쓰기
								</md-button>
							</div>
						</div>
				        <table cellpadding=0 cellspacing=0 border=0>
						       <tr>
							        <th style="width:50px">NO</th>
									<th>제목</th>
									<th style="width:100px" v-if="bid=='question'">답변여부</th>
									<th style="width:100px">작성자</th>
									<th style="width:100px">등록일</th>
							   </tr>
							   <tr @click="goView(info.no)" v-for="info in boardList">
							        <td>{{info.keynum}}</td>
									<td style="text-align:left;padding-left:15px;">{{info.subject}}</td>
									<td v-if="bid=='question'">
										<span v-if="info.summary">답변완료</span>
										<span v-else style="color:#f00">미답변</span>

									
									</td>
									<td>{{info.name}}</td>
									<td>{{info.regdate}}</td>
							   </tr> 
						</table>
				   </div>
				   <Paganation :paging="pagingData" @getDataListByPaging="getDataListByPaging"></Paganation>
	         </div>
	   </div>

		
	 <FooterLayout></FooterLayout>
	</div>
</template>

<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'
import Paganation from '@/components/inc/Paganation'


export default {
	name: 'BoardArticleList',
	components: {
		HeaderLayout,
		FooterLayout,
		Paganation,
	},
	props:["bid"],
	data () {
		return {
			boardName:'',
			boardList:[],
			limit:2,
			pagingData:{},
			
		}	
	},
	created: function() {
		
		this.getData(1);

	},
	methods: {
		getData(page) {

			var params = {bid:this.bid,page:page,limit:this.limit};
			var obj = this;
			this.$form.sendPost(params,'boardApp/articleList',function(resp) {

				obj.boardName = resp.board_info.name;
				obj.boardList = resp.datas.datas
				
				obj.pagingData = resp.datas.paging;
				

			});


		},
		goView(no) {
		   
			this.$router.push({ path:'/board/view/'+no})
	    },
		writeBoard() {
			this.$router.push({path:'/board/write/'+this.bid});
		},
		 getDataListByPaging(number) {
			this.getData(number);

	   },

    },
	beforeDestroy() {
		//$(window).off("scroll");
	},
	mounted() {
		//$(window).on("scroll" ,this.scrollHandler);
	},

}
</script>

<style lang="scss" scoped>

.page-container {
	background:#fff;
	padding:0;
	margin:0;
	min-height:calc(100vh);
	.content           {
						 width:100%;
		                 height:auto;
				         min-height:800px;
						 padding:130px 0 50px; 
						 font-family: 'Nanum Gothic', sans-serif;
						 background:#fff;
						 overflow:auto;
						 .content-main          {
						 				width:830px;
										margin:0 auto;
										.box-table  {
													width:100%;
													.board-header {
														width:100%;
														display:flex;
														div:first-child {
															width:700px;
															.text-name        {
																font-size:11px;
																color:#3F3F3F;
															}
														}
														div:last-child {
															width:130px;
															.md-button {
																width:130px;
																min-width:130px;
																margin:0;
															}
														}
													}
													table             {
																width:100%;
																height:auto;
																margin-top:15px;
																margin-bottom:50px;
																th          {
																	   text-align:center;
																	   height:45px;
																	   line-height:45px;
																	   border-top:1px solid #3D79FE;
																	   font-size:15px;
																	   color:#3D79FE;
																	   padding-left:15px;
																	   border-bottom:1px solid #DFDFDF;
																}
																td          {
																       text-align:center;
																	   height:40px;
																	   line-height:40px;
																	   border-bottom:1px solid #DFDFDF;
																	   font-size:13px;
																       color:#B7B7B7;
																	   cursor:pointer;
																	   padding-left:15px;
																}
																.text        {
																	   border-bottom:1px solid #DFDFDF;
																}
													}
										}
									    .box-list        {
													width:130px;
													margin:0 auto;
													ul         {
													           display:flex;
															   li        { 
															         margin-left:12px;
																	 font-size:15px;
																	 color:#B9B9B9;
															         &:first-child     {
																	 		       width:20px;
																				   height:20px;
																				   border:1px solid #B9B9B9;
																				   text-align:center;
																				   line-height:20px;
																				   border-radius:50%;
																				   font-size:10px;
																	 }
																	 &:last-child     {
																	 		       width:20px;
																				   height:20px;
																				   border:1px solid #B9B9B9;
																				   text-align:center;
																				   line-height:20px;
																				   border-radius:50%;
																				   font-size:10px;
																	 }
															   }
															   li.active      {
															   			  color:#3D79FE;
															   }
													}
										}
						 }
			}
}
</style>